import React, { useState } from 'react';
import Select from 'react-select';
import type { MultiValue } from 'react-select';

interface UserOption {
  value: number;
  label: string;
}

interface Props {
  deptId: number;
  users: UserOption[];
  assignedUserIds: number[];
}

export default function DepartmentUserSelect({ deptId, users, assignedUserIds }: Props) {
  const [selectedIds, setSelectedIds] = useState<number[]>(assignedUserIds);
  const inputName = `company[department_user_ids][${deptId}][]`;

  function handleChange(selectedOptions: MultiValue<UserOption>) {
    setSelectedIds((selectedOptions || []).map(o => o.value));
  }

  return (
    <>
      <Select
        classNamePrefix="react-select-buildout"
        isMulti
        options={users}
        styles={{
          valueContainer: base => ({ ...base, flexWrap: 'wrap' }),
        }}
        value={users.filter(u => selectedIds.includes(u.value))}
        onChange={handleChange}
      />
      {selectedIds.map(userId => (
        <input key={userId} name={inputName} type="hidden" value={userId} />
      ))}
    </>
  );
}
